import React from "react";
import "./PartnerStudio.css";

const PartnerStudio = ({
  image,
  logo,
  title,
  address,
  google_maps_url,
  bookings_url,
  email,
  city,
  state,
  country,
  socialLinks = [],
  instructors = [],
  class_types = [],
}) => {
  const locationText = [city, state, country].filter(Boolean).join(", ");
  return (
    <div className="card no-scale p-0 partner-studio">
      <div className="card__content partner-studio__image-wrap">
        <img
          className="premises-img"
          alt={title}
          src={image}
        />
        {logo && (
          <div className="partner-studio__logo-overlay">
            <img
              src={logo}
              alt={title}
              className="partner-studio__logo"
            />
          </div>
        )}
      </div>
      <div className="partner-studio__content">
        <div className="partner-studio__main-row">
          <div className="partner-studio__left">
            <h2 className="partner-studio__title">{title}</h2>

            {address && (
              <div className="partner-studio__section">
                <div className="partner-studio__label">Dirección</div>
                {google_maps_url ? (
                  <a
                    href={google_maps_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="partner-studio__link"
                  >
                    {typeof address === "string" && address.includes("\n")
                      ? address.split("\n").map((line, i) => (
                          <React.Fragment key={i}>
                            {i > 0 && <br />}
                            {line}
                          </React.Fragment>
                        ))
                      : address}
                  </a>
                ) : (
                  <div className="partner-studio__value">{address}</div>
                )}
              </div>
            )}
            {class_types.length > 0 && (
              <div className="partner-studio__badges">
                {class_types.map((ct, index) => (
                  <div key={index} className="partner-studio__badge">
                    <i className="fa fa-check-circle partner-studio__badge-icon" />
                    <span>{ct.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="partner-studio__right">
            {locationText && (
              <div className="partner-studio__location mb-2">{locationText}</div>
            )}
            {bookings_url && (
              <a
                href={bookings_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary partner-studio__btn-reservar"
              >
                Reservar
              </a>
            )}
            {instructors.length > 0 && (
              <div className="partner-studio__coaches">
                <div className="partner-studio__coaches-label">Coaches certificados</div>
                <div className="partner-studio__coaches-list">
                  {instructors.map((coach, index) => (
                    <div key={index} className="partner-studio__coach">
                      <img
                        src={coach.image}
                        alt={coach.name}
                        className="partner-studio__coach-img"
                      />
                      <span className="partner-studio__coach-name">{coach.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {(email || socialLinks.length > 0) && (
          <div className="partner-studio__social">
            {email && (
              <a
                href={`mailto:${email}`}
                className="partner-studio__social-icon"
                title="Email"
                aria-label="Email"
              >
                <i className="far fa-envelope" />
              </a>
            )}
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-studio__social-icon"
                title={link.label || link.type}
                aria-label={link.label || link.type}
              >
                {link.type === "instagram" && <i className="fab fa-instagram" />}
                {link.type === "web" && <i className="fas fa-globe" />}
                {link.type === "whatsapp" && <i className="fab fa-whatsapp" />}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerStudio;
